import secureApi from '../../utils/secureApi';
import { NewsArticleAddPayload, NewsArticle } from './types';

export async function addNewsArticle(payload: NewsArticleAddPayload) {
  const response = await secureApi.post<any>(
    `/api/v1/blogs/admin/news/add`,
    payload
  );
  
  // secureApi returns response.data automatically
  // Handle API response structure: may be wrapped in { statusCode, data: {...} } or direct
  if (response && response._id) {
    return response as NewsArticle; // Already the expected structure
  } else if (response && (response as any).data && (response as any).data._id) {
    return (response as any).data as NewsArticle; // Wrapped in data field
  }
  return response as NewsArticle; // Fallback
}
